/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import { Random } from "random-js";
import ls from "@/common/localStorage"

var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var cn = ls.getSessionEventCollectionName();
var ClientCollectionName = 'OA_UAT';
const checkoutFormsRef = con.eventDB.collection(cn).doc('FormList').collection('CheckoutForms')
var registrationTypesRef = con.eventDB.collection(cn).doc("RegistrationTicketList").collection("RegistrationTicketTypes");
const storageRef = con.storageRef

const ticketJsonPath = cn + '/Registration/CheckoutForms.JSON';
const ticketInstanceJsonPath = ClientCollectionName + '/Defaults/CheckoutForms.JSON';
var UpdateUserDataAPI = con.UpdateUserDataAPI;
var saveRegistrationTypeAPI = con.saveRegistrationTypeAPI;
var saveCheckoutFormAPI = con.saveCheckoutFormAPI;
var GetsubcollectionsApi = con.GetsubcollectionsApi;
var getCollectionDocsAPI = con.getCollectionDocsAPI;
var getSingleDocAPI = con.getSingleDocAPI;
var regFormAPI = con.regFormAPI;
var UploadFilesAPI = con.UploadFilesAPI

export default {
  readCheckoutFormsJson(context) {
    return new Promise((resolve, reject) => {
      let jsonObj = null
      storageRef.child(ticketJsonPath).getDownloadURL().then(function (url) {
        axios.get(url.toString()).then(result => {
          if (typeof result.data == 'string')
            jsonObj = eval('(' + result.data + ')');
          else if (typeof result.data == 'object')
            jsonObj = result.data
          else
            jsonObj = null
          resolve(jsonObj)
        })
      }).catch(function () {
        resolve(
          {
            CheckoutForms: [],
            RegistrationTypes: [],
            Config: {
              "PayingToLogo": "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FClients%2FC1591205467009%2Flogo.jpg?alt=media&token=38fe4480-0fa9-4f97-a7cd-3e986fdff3e6",
              "RegFormSideBanner": null,
              "SubmitButtonDisplaylabel": "SUBMIT",
              "PayingTo": "Web Spiders",
              "LandingPageShowHostedByPanel": true,
              "LandingPageShowEventListLink": true
            }
          }
        )
      })
    })
  },
  fetchRegistrationTypes(context) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }
      let requestData = {
        "key": {
          "instanceId": "OA_UAT",
          "clientId": Session_Client_Id,
          "eventId": Session_Event_Id
        },
        "data": {
          "filter": [{
            "key": "RegistrationType",
            "operator": "!=",
            "value": "null"
          }],
          "collection": "RegistrationTicketList/RegistrationTicketTypes",
          "dockey": "RegistrationTypeId"
        }
      };
      axios.post(getCollectionDocsAPI, requestData, { headers: headers }).then(function (res) {
        if (res.data.status == 0) {
          context.commit('SET_TICKETS', res.data.result)
          resolve(res.data.result)
        }
      }).catch(err => { reject(err) })

    })
  },
  fetchRegistrationType(context, id) {
    //console.log(id)
    return new Promise((resolve, reject) => {
      if (id === null) {
        resolve({
          status: 200,
          data: {
            RegistrationTypeId: null,
            RegistrationType: null,
            ColorCode: '#000',
            FormType: 'Free',
            Currency: null,
            Price: 0.00,
            PriceIncludingTax: true,
            Tax: 0,
            Quantity: 1,
            Expiry: 5,
            MinLimit: 1,
            MaxLimit: 1,
            Description: null,
            SaleStartDate: new Date(),
            SaleEndDate: new Date(),
            IsPublished: true,
            Visibility: true,
            AdvancedSettings: false
          }
        })
      } else {
        let headers = {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
        }
        let requestData = {
          "collection": `${cn}/RegistrationTicketList/RegistrationTicketTypes`,
          "doc": `${id}`
        };
        axios.post(getSingleDocAPI, requestData, { headers: headers }).then(function (res) {
          if (res.data.status == 0) {
            let data = res.data.result;
            data.RegistrationType = data.RegistrationType ? data.RegistrationType : null;
            data.ColorCode = data.ColorCode ? data.ColorCode : null;
            data.FormType = data.FormType ? data.FormType : 'Free';
            data.Currency = data.Currency ? data.Currency : null;
            data.Price = data.Price ? Number(data.Price) : 0.00;
            data.PriceIncludingTax = data.PriceIncludingTax ? data.PriceIncludingTax : true;
            data.Tax = data.Tax ? Number(data.Tax) : 0.00;
            data.Quantity = data.Quantity ? Number(data.Quantity) : 1;
            data.Expiry = data.Expiry ? data.Expiry : 2;
            data.MinLimit = data.MinLimit ? Number(data.MinLimit) : 1;
            data.MaxLimit = data.MaxLimit ? Number(data.MaxLimit) : 1;
            data.Description = data.Description ? data.Description : null;
            data.SaleStartDate = data.SaleStartDate ? new Date(data.SaleStartDate._seconds * 1000) : new Date();
            data.SaleEndDate = data.SaleEndDate ? new Date(data.SaleEndDate._seconds * 1000) : new Date();
            data.IsPublished = data.IsPublished ? true : false;
            data.Visibility = data.Visibility ? true : false;
            data.AdvancedSettings = data.AdvancedSettings ? data.AdvancedSettings : false;
            resolve({ status: 200, data: data })
          }
        }).catch(err => { reject(err) })

      }
    })
  },
  addDBRegistrationType(context, dataObj) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
        "instanceId": "OA_UAT",
        "clientId": Session_Client_Id,
        "eventId": Session_Event_Id
      }
      let requestData = {
        "data": dataObj
      };
      axios.post(saveRegistrationTypeAPI, requestData, { headers: headers }).then(function (res) {
        let RegistrationTypeId = null;
        if (res.data.status == 0) {
          RegistrationTypeId = res.data.RegistrationTypeId ? res.data.RegistrationTypeId : null;
          resolve({ status: 200, message: "Data Added.", RegistrationTypeId: RegistrationTypeId })
        } else {
          resolve({ status: 200, message: "Data not Added.", RegistrationTypeId: RegistrationTypeId })
        }
      }).catch(err => { reject(err) })
    })
  },
  editDBRegistrationType(context, dataObj) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
        "instanceId": "OA_UAT",
        "clientId": Session_Client_Id,
        "eventId": Session_Event_Id
      }
      let key = { RegistrationTypeId: dataObj.id }
      delete dataObj.id;
      let requestData = {
        "key": key,
        "data": dataObj
      };
      axios.put(saveRegistrationTypeAPI, requestData, { headers: headers }).then(function (res) {
        if (res.data.status == 0) {
          //context.dispatch('saveRegistrationTypesJson');
          resolve({ status: 200, message: "Data Updated." })
        }
        else
          resolve({ status: 500, message: "Data not Updated!" })
      }).catch(err => { reject(err) })
    })
  },
  updateRegistrationTypeNameColorCode(context, field) {
    return new Promise((resolve, reject) => {
      let dataObj = {
        id: field.RegistrationTypeId,
        RegistrationType: field.data.RegistrationType.trim(),
        ColorCode: field.data.ColorCode.trim()
      }
      context.dispatch('editDBRegistrationType', dataObj).then(response => {
        if (response.status == 200)
          //context.dispatch('saveRegistrationTypesJson');
        resolve(response);
      }).catch(err => { reject(err) })
    })
  },
  updateRegistrationType(context, field) {
    return new Promise((resolve, reject) => {
      let dataObj = {
        id: field.RegistrationTypeId,
        RegistrationType: field.data.RegistrationType.trim(),
        ColorCode: field.data.ColorCode ? field.data.ColorCode.trim() : '#000',
        FormType: field.data.FormType,
        Currency: field.data.Currency,
        Price: Number(field.data.Price),
        PriceIncludingTax: field.data.PriceIncludingTax,
        Tax: Number(field.data.Tax),
        Quantity: Number(field.data.Quantity),
        Expiry: Number(field.data.Expiry),
        MinLimit: Number(field.data.MinLimit),
        MaxLimit: Number(field.data.MaxLimit),
        Description: field.data.Description,
        SaleStartDate: new Date(field.data.SaleStartDate).toUTCString(),
        SaleEndDate: new Date(field.data.SaleEndDate).toUTCString(),
        IsPublished: field.data.IsPublished ? true : false,
        Visibility: field.data.Visibility ? true : false,
        AdvancedSettings: field.data.AdvancedSettings,
        TicketPriceID: field.data.TicketPriceID
      }
      context.dispatch('editDBRegistrationType', dataObj).then(response => {
        if (response.status == 200)
          //context.dispatch('saveRegistrationTypesJson');
        resolve(response);
      }).catch(err => { reject(err) })
    })
  },
  addRegistrationType(context, field) {
    return new Promise((resolve, reject) => {
      let dataObj = {
        RegistrationTypeId: null,
        RegistrationType: field.data.RegistrationType.trim(),
        ColorCode: field.data.ColorCode.trim(),
        FormType: field.data.FormType,
        Currency: field.data.Currency,
        Price: Number(field.data.Price),
        PriceIncludingTax: field.data.PriceIncludingTax,
        Tax: Number(field.data.Tax),
        Quantity: Number(field.data.Quantity),
        Expiry: Number(field.data.Expiry),
        MinLimit: Number(field.data.MinLimit),
        MaxLimit: Number(field.data.MaxLimit),
        Description: field.data.Description,
        SaleStartDate: new Date(field.data.SaleStartDate).toUTCString(),
        SaleEndDate: new Date(field.data.SaleEndDate).toUTCString(),
        IsPublished: field.data.IsPublished ? true : false,
        Visibility: field.data.Visibility ? true : false,
        AdvancedSettings: field.data.AdvancedSettings
      }
      context.dispatch('addDBRegistrationType', dataObj).then(response => {
        if (response.RegistrationTypeId)
          //context.dispatch('saveRegistrationTypesJson');
        resolve(response);
      }).catch(err => { reject(err) })
    })
  },
  generateNumber(context) {
    const random = new Random(); // uses the nativeMath engine
    //const value = random.hex(numberLength);
    const value = random.hex(15);
    return value.toString();
  },
  fetchCheckoutForms(context) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }
      let requestData = {
        "key": {
          "instanceId": "OA_UAT",
          "clientId": Session_Client_Id,
          "eventId": Session_Event_Id
        },
        "data": {
          "filter": [{
            "key": "FormTitle",
            "operator": "!=",
            "value": "null"
          }],
          "collection": "FormList/CheckoutForms",
          "dockey": "FormId"
        }
      };
      axios.post(getCollectionDocsAPI, requestData, { headers: headers }).then(function (res) {
        if (res.data.status == 0) {
          context.commit('SET_FORMS', res.data.result)
          resolve(res.data.result)
        }
      }).catch(err => { reject(err) })

    })
  },
  fetchCheckoutForm(context, id) {
    return new Promise((resolve, reject) => {
      if (id === null) {
        resolve({
          status: 200,
          data: {
            FormId: null,
            FormTitle: null,
            RegistrationTypes: [],
            DefaultFields: [],
            PreSignupFields: null,
            DynamicFields: [],
            IsPublished: true,
            CreatedDate: new Date(),
            LastModifiedDate: new Date(),
          }
        })
      } else {
        let headers = {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
        }
        let requestData = {
          "collection": `${cn}/FormList/CheckoutForms`,
          "doc": `${id}`
        };
        axios.post(getSingleDocAPI, requestData, { headers: headers }).then(function (res) {
          if (res.data.status == 0) {
            resolve({ status: 200, data: res.data.result })
          }
        }).catch(err => { reject(err) })
      }

    })
  },
  addCheckoutForm(context, field) {
    return new Promise((resolve, reject) => {
      context.dispatch('generateNumber').then(randomNumber => {
        let dataObj = {
          FormId: null,
          FormTitle: field.FormTitle.trim(),
          RegistrationTypes: field.RegistrationTypes,
          DefaultFields: field.DefaultFields,
          PreSignupFields: field.PreSignupFields,
          DynamicFields: field.DynamicFields,
          IsPublished: true
        }
        let headers = {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
          "instanceId": "OA_UAT",
          "clientId": Session_Client_Id,
          "eventId": Session_Event_Id
        }
        let requestData = {
          "data": dataObj
        };
        axios.post(saveCheckoutFormAPI, requestData, { headers: headers }).then(function (res) {
          if (res.data.status == 0) {
            //context.dispatch('saveCheckoutFormsJson');
            resolve({ status: 200, message: "Form Added." })
          } else {
            resolve({ status: 500, message: "Form Not Added!" })
          }
        }).catch(err => { reject(err) })
      })
    })
  },
  updateCheckoutForm(context, field) {
    return new Promise((resolve, reject) => {
      let dataObj = {
        FormTitle: field.FormTitle.trim(),
        RegistrationTypes: field.RegistrationTypes,
        DefaultFields: field.DefaultFields,
        PreSignupFields: field.PreSignupFields,
        DynamicFields: field.DynamicFields,
      }
      let key = { FormId: field.FormId }
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
        "instanceId": "OA_UAT",
        "clientId": Session_Client_Id,
        "eventId": Session_Event_Id
      }
      let requestData = {
        "key": key,
        "data": dataObj
      };
      axios.put(saveCheckoutFormAPI, requestData, { headers: headers }).then(function (res) {
        if (res.data.status == 0) {
          //context.dispatch('saveCheckoutFormsJson');
          resolve({ status: 200, message: "Form Updated." })
        } else {
          resolve({ status: 500, message: "Form Not Updated!" })
        }
      }).catch(err => { reject(err) })
    })
  },
  updatecheckoutFormRandomField(context, field) {
    return new Promise((resolve, reject) => {
      let dataObj = field;
      let key = { FormId: field.id }
      delete dataObj.id
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
        "instanceId": "OA_UAT",
        "clientId": Session_Client_Id,
        "eventId": Session_Event_Id
      }
      let requestData = {
        "key": key,
        "data": dataObj
      };
      axios.put(saveCheckoutFormAPI, requestData, { headers: headers }).then(function (res) {
        if (res.data.status == 0) {
          //context.dispatch('saveCheckoutFormsJson');
          resolve({ status: 200, message: "Form Updated." })
        } else {
          resolve({ status: 500, message: "Form Not Updated!" })
        }
      }).catch(err => { reject(err) })
    })
  },
  saveCheckoutFormsJson(context) {
    return new Promise((resolve, reject) => {
      context.dispatch('readCheckoutFormsJson').then(function (jsonObj) {
        if (jsonObj) {
          let headers = {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
          }
          let requestData = {
            "key": {
              "instanceId": "OA_UAT",
              "clientId": Session_Client_Id,
              "eventId": Session_Event_Id
            },
            "data": {
              "filter": [{
                "key": "FormTitle",
                "operator": "!=",
                "value": "null"
              }],
              "collection": "FormList/CheckoutForms",
              "dockey": "FormId"
            }
          };
          axios.post(getCollectionDocsAPI, requestData, { headers: headers }).then(function (res) {
            if (res.data.status == 0) {
              jsonObj.CheckoutForms = res.data.result;
              let json = JSON.stringify(jsonObj, null, 2);
              const blob = new Blob([json], { type: "application/json" });
              storageRef.child(ticketJsonPath).put(blob, { 'contentType': 'application/json' }).then(function (snapshot) {
                resolve({ status: 200, message: "JSON Updated" })
              })
            }
          }).catch(err => { reject(err) })

        }
        else {
          resolve({ status: 200, message: 'Nothing to update!' })
        }
      })
    })
  },
  saveRegistrationTypesJson(context) {
    return new Promise((resolve, reject) => {
      context.dispatch('readCheckoutFormsJson').then(function (jsonObj) {
        if (jsonObj) {
          let headers = {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
          }
          let requestData = {
            "key": {
              "instanceId": "OA_UAT",
              "clientId": Session_Client_Id,
              "eventId": Session_Event_Id
            },
            "data": {
              "filter": [{
                "key": "RegistrationType",
                "operator": "!=",
                "value": "null"
              }],
              "collection": "RegistrationTicketList/RegistrationTicketTypes",
              "dockey": "RegistrationTypeId"
            }
          };
          axios.post(getCollectionDocsAPI, requestData, { headers: headers }).then(function (res) {
            if (res.data.status == 0) {
              let RegistrationTypes = res.data.result;
              for (let item in RegistrationTypes) {
                RegistrationTypes[item].SaleStartDate = new Date(RegistrationTypes[item].SaleStartDate._seconds * 1000).toUTCString();
                RegistrationTypes[item].SaleEndDate = new Date(RegistrationTypes[item].SaleEndDate._seconds * 1000).toUTCString();
              }
              jsonObj.RegistrationTypes = RegistrationTypes;
              let json = JSON.stringify(jsonObj, null, 2);
              const blob = new Blob([json], { type: "application/json" });
              storageRef.child(ticketJsonPath).put(blob, { 'contentType': 'application/json' }).then(function (snapshot) {
                resolve({ status: 200, message: "JSON Updated" })
              })
            }
          }).catch(err => { reject(err) })

        }
        else {
          resolve({ status: 200, message: 'Nothing to update!' })
        }
      })
    })
  },
  getCurrencies(context) {
    return new Promise((resolve, reject) => {
      axios.get("https://resources.e2m.live/e2monair.appspot.com/OA_UAT/Defaults/currencies.json").then((res) => {
        if (res.status == 200)
          resolve(res.data);
        else
          resolve([])
      }).catch(err => { reject(err) })
    })
  },
  getRegFormConfig(context) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
        "instanceId": "OA_UAT",
        "clientId": Session_Client_Id,
        "eventId": Session_Event_Id
      }

      axios.get(regFormAPI, { headers: headers }).then(function (res) {
        if (res.data.status == 0) {
          resolve({ status: 200, data: res.data.data })
        } else {
          resolve({ status: 500, data: null })
        }
      }).catch(err => { reject(err) })

    })
  },
  setRegFormConfig(context, data) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }

      let requestData = {
        "key": {
          "instanceId": "OA_UAT",
          "clientId": Session_Client_Id,
          "eventId": Session_Event_Id
        },
        "data": data
      };
      //context.dispatch('readCheckoutFormsJson').then(function (jsonObj) {
        axios.post(regFormAPI, requestData, { headers: headers }).then(function (res) {
          if (res.data.status == 0) {
            /*jsonObj.Config = data;
            let json = JSON.stringify(jsonObj, null, 2);
            const blob = new Blob([json], { type: "application/json" });
            storageRef.child(ticketJsonPath).put(blob, { 'contentType': 'application/json' }).then(function (snapshot) {
              resolve({ status: 200, message: "Data saved successfully." })
            })*/
            resolve({ status: 200, message: "Data saved successfully." })
          } else {
            resolve({ status: 500, message: "Data not saved!" })
          }
        }).catch(err => { reject(err) })
      //})

    })
  },
  uploadFiles(context, field) {
    return new Promise((resolve, reject) => {
      let accessToken = ls.getSessionValueByKey('Session_AccessToken');
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${accessToken}`
      }
      let requestData = {
        "key": {
          "instanceId": "OA_UAT",
          "clientId": Session_Client_Id,
          "eventId": Session_Event_Id,
        },
        files: field
      };
      axios.post(UploadFilesAPI, requestData, { headers: headers }).then(function (res) {
        if (res.data.status == 0)
          resolve({ status: 200, data: res.data.data })
        else
          resolve({ status: 500, data: [] })
      }).catch(err => { reject(err) })
    })
  },
  removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/user-management/users/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
